export default {"src":"/_next/static/media/alarm.350cfef3.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};